<template>
    <div v-loading="loading" style="min-height: 500px;" class="switch-set" v-cloak>
        <div v-if="menuChnlEnabled">
            <el-tabs v-if="sysMenuChnls !=  null && sysMenuChnls.length > 0" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="item in sysMenuChnls" :label="item.name" :name="item.name">
                    <div v-if="item.sysMenus != null" v-for="sysMenu in item.sysMenus">
                        <div style="margin: 5px 0;" class="content-caption dashed">
                            <span><span class="color-laber"></span>{{sysMenu.name}}</span>
                            <!-- :indeterminate="isIndeterminate" -->
                            <el-checkbox disabled v-model="stateMap[sysMenu.id].checked" :indeterminate="stateMap[sysMenu.id].indeterminate" @change="((event)=>{handleCheckAllChange(event, sysMenu.id)})">
                                <span>全选</span>
                            </el-checkbox>
                        </div>
                        <ul class="switch-list clearfix ml10">
                            <el-checkbox-group v-model="rescIds" @change="((event)=>{handleCheckedResourcesChange(event, sysMenu.id)})">
                                <li v-for="sysMenuSon in sysMenu.sysMenuSons" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                                    <el-checkbox disabled v-if="sysMenuSon.sysResc != null" :label="sysMenuSon.sysResc.id">
                                    <span :class="{'font-italic font-gray2 mr5' : sysMenuSon.sysResc.hiddenMenuFlag}">
                                        <i class="icon iconfont icon-wujiaoxingman mr5" style="color: #eaea0f;"></i>
                                        <span>{{sysMenuSon.name}}</span>
                                    </span>
                                    </el-checkbox>
                                    <span class="biz-union-indent" v-if="sysMenuSon.sysResc != null && sysMenuSon.sysResc.forBizUnionOnly">联盟专用</span>
                                </li>
                            </el-checkbox-group>
                        </ul>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-else>
            <div v-if="sysMenuChnl.sysMenus != null" v-for="sysMenu in sysMenuChnl.sysMenus">
                <div style="margin: 5px 0;" class="content-caption dashed">
                    <span><span class="color-laber"></span>{{sysMenu.name}}</span>
                </div>
                <ul class="switch-list clearfix ml10">
                    <el-checkbox-group v-model="rescIds">
                        <li v-for="sysMenuSon in sysMenu.sysMenuSons" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                            <el-checkbox disabled v-if="sysMenuSon.sysResc != null" :label="sysMenuSon.sysResc.id">
                            <span :class="{'font-italic font-gray2 mr5' : sysMenuSon.sysResc.hiddenMenuFlag}">
                                <i class="icon iconfont icon-wujiaoxingman mr5" style="color: #eaea0f;"></i>
                                <span>{{sysMenuSon.name}}</span>
                            </span>
                            </el-checkbox>
                            <span class="biz-union-indent" v-if="sysMenuSon.sysResc != null && sysMenuSon.sysResc.forBizUnionOnly">联盟专用</span>
                        </li>
                    </el-checkbox-group>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    //
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'

    import settingApi from '../../api/setting'
    import merchtAllApi from '../../api/merchtAll'

    //
    export default {
        name: 'swb-tpl-com-role-resc-list',
        desc: '模版岗位资源列表',
        props: ['roleId', 'scopeCode'],
        data: function () {
            //
            return {
                loading: false,
                roleRescList: [],
                menuChnlEnabled: false,
                sysMenuChnl: {
                    sysMenus: []
                },
                activeName: null,
                sysMenuChnls: [],
                rescIds: [],
                //
                // isIndeterminate: true,
                rescIdsMap: {},
                stateMap: {}
            }
        },
        created: function () {
            this.getTplComRoleRescIdsByRoleId();
            this.getSysMenuChnlList();
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            getSysMenuChnlList: function () {
                let self = this;
                let postData = {};
                postData.tplFlag = true;
                this.loading = true;
                settingApi.getSysMenuChnlListForRole(postData, function (result, jqXhr) {
                    self.loading = false;
                    if(result.type == 'info') {
                        if(result.code == 1) {
                            self.menuChnlEnabled = true;
                        }
                        self.sysMenuChnl = result.data[0] || {};
                        self.activeName = self.sysMenuChnl.name || null;
                        let sysMenuChnls = result.data || [];
                        //
                        if(!Utils.isNoB(sysMenuChnls) && sysMenuChnls.length > 0) {
                            sysMenuChnls.forEach(function (sysMenuChnl) {
                                let sysMenus = sysMenuChnl.sysMenus;
                                sysMenus.forEach(function (sysMenu) {
                                    let sysMenuSons = sysMenu.sysMenuSons;
                                    // let rescIds = sysMenuSons.pluck("rescId");
                                    // console.log("所有的rescIds = ", rescIds);
                                    self.rescIdsMap[sysMenu.id] = sysMenuSons.pluck("rescId");
                                    //
                                    self.checkState(sysMenu.id);
                                });
                            });
                            console.log(self.rescIdsMap);
                        }
                        self.sysMenuChnls = sysMenuChnls;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getTplComRoleRescIdsByRoleId: function () {
                let self = this;
                let postData = {};
                postData.roleId = self.roleId;
                merchtAllApi.getTplComRoleRescIdsByRoleId(postData, function (result) {
                    if(result.type == 'info') {
                        self.rescIds = result.data || [];
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            handleCheckAllChange(checked, sysMenuId) {
                let rescIdsMap = this.rescIdsMap;
                let curRescIds = rescIdsMap[sysMenuId];  // 当前组的 rescIds
                let rescIds = this.rescIds;
                curRescIds.forEach(function (curRescId) {
                    if(checked && rescIds.indexOf(curRescId) < 0) {    // 全选-没选中的全add
                        rescIds.add(curRescId);
                    } else if(!checked && rescIds.indexOf(curRescId) >= 0) { // 全不选-已选中的全remove
                        rescIds.remove(curRescId);
                    }
                });
                this.rescIds = Utils.merge([], rescIds);
                this.stateMap[sysMenuId].indeterminate = false;
            },
            checkState: function (sysMenuId) {
                let self = this;
                let curRescIds = this.rescIdsMap[sysMenuId];  // 当前组的 rescIds
                let rescIds = this.rescIds;
                //
                let noInclude = false; // 是否有没选中的
                let include = false;    // 是否有选中的
                curRescIds.forEach(function (curRescId) {
                    rescIds.indexOf(curRescId) < 0 ? noInclude = true : include = true;
                });
                // 默认全选
                let checked = true;
                let indeterminate = false;
                if(noInclude && !include) {
                    checked = false; // 全不选
                } else if(include && noInclude) {
                    indeterminate = true; // 半选
                }
                let stateMap = self.stateMap;
                stateMap[sysMenuId] = {
                    checked: checked,
                    indeterminate: indeterminate
                };
                self.stateMap = Utils.merge({}, stateMap);
            },
            handleCheckedResourcesChange(event, sysMenuId) {
                //
                this.checkState(sysMenuId);
            },
            notityChange: function () {
                // 发生变化时向上传递
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let resultItenIds = this.rescIds;
                //
                let result = {};
                if(resultItenIds.length > 0) {
                    result.type = 'info';
                    result.data = resultItenIds;
                } else {
                    result.type = 'warn';
                    result.message = '至少开启一个岗位资源';
                }

                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/comn/TplComRoleRescList.vue